import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatSelectModule} from '@angular/material/select';
import {MatInputModule} from '@angular/material/input';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatIconModule} from '@angular/material/icon';
import {MatButtonModule} from '@angular/material/button';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatChipsModule} from '@angular/material/chips';
import {AutoFocusDirective} from './directives/auto-focus.directive';
import {IsDecimalDirective} from './directives/is-decimal-directive.directive';
import {UserCardComponent} from './components/user-card/user-card.component';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatCardModule} from '@angular/material/card';
import {MatTooltipModule} from '@angular/material/tooltip';
import {ConfirmationDialogComponent} from './components/confirmation-dialog/confirmation-dialog.component';
import {MatDialogModule} from '@angular/material/dialog';
import {ValidationErrorsComponent} from './components/validation-errors/validation-errors.component';
import {CommaRemovalPipe} from './pipes/comma-removal.pipe';
import {SortPipe} from './pipes/sort.pipe';
import {StatePipe} from './pipes/state.pipe';
import {PhonePipe} from './pipes/phone.pipe';
import {ArchivePipe} from './pipes/archive.pipe';
import {UnderscoreRemove} from './pipes/underscore-remove.pipe';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {WhitespacePipe} from './pipes/whitespace.pipe';
import { DelimitedListComponent } from './components/delimited-list/delimited-list.component';

@NgModule({
	declarations: [
		AutoFocusDirective,
		IsDecimalDirective,
		UserCardComponent,
		ConfirmationDialogComponent,
		ValidationErrorsComponent,
		CommaRemovalPipe,
		SortPipe,
		StatePipe,
		ArchivePipe,
		PhonePipe,
		UnderscoreRemove,
		WhitespacePipe,
  DelimitedListComponent
	],
  exports: [
    AutoFocusDirective,
    IsDecimalDirective,
    UserCardComponent,
    ValidationErrorsComponent,
    StatePipe,
    PhonePipe,
    SortPipe,
    ArchivePipe,
    UnderscoreRemove,
    WhitespacePipe,
    DelimitedListComponent
  ],
	imports: [
		CommonModule,
		MatFormFieldModule,
		MatInputModule,
		MatSelectModule,
		ReactiveFormsModule,
		MatProgressSpinnerModule,
		MatIconModule,
		MatButtonModule,
		MatAutocompleteModule,
		MatChipsModule,
		MatCheckboxModule,
		MatCardModule,
		MatTooltipModule,
		MatDialogModule,
		FormsModule,
		MatDatepickerModule
	],
	providers: [CommaRemovalPipe, SortPipe, UnderscoreRemove]
})
export class SharedModule {}
